import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { NavLink } from 'react-router-dom';
import "../styles/trailer.css";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { IoMdSend } from "react-icons/io";
// import { baseUrl } from '../config';



export default function Trailer(){
    let st = "closed";
    function edit(s){
        if (st === "closed") {
            document.getElementById('editClosed').style.display = 'none';
            document.getElementById('editOpen').style.display = 'block';
            st = "open";
        }
        else{
            document.getElementById('editClosed').style.display = 'block';
            document.getElementById('editOpen').style.display = 'none';
            st = "closed";
        }
    }
    return(
        <div id="trailer">
            <SEO
              title="Trailer Creation Tool"
              description="Create and manage your film's trailer with ProducerBuddy's built-in trailer editing and preview tools."
              url="https://producerbuddy.pilomation.com/trailer"
              robots="noindex, nofollow"
            />
            <SubNav />
            <div id='trailerWrapper'>
                <details id='editor'>
                    <summary onClick={() => {edit()}}><MdKeyboardDoubleArrowLeft id='editOpen'/><MdKeyboardDoubleArrowRight id='editClosed'/></summary>
                    <h2>Editing</h2>
                    <p>Video Effects</p>
                    <p>Soundtrack</p>
                    <p>Cut and Crop</p>
                    <p>Saturation</p>
                    <p>Blur</p>
                    <p>Playback speed</p>
                    <p>VFX</p>
                </details>
                <div id='trailerBot'>
                    <div id='trailerMessages'>
                        <div className='trailerBotMessage'>
                            <p>Input a prompt to start to generate a trailer.</p>
                        </div>
                    </div>
                    <div id='trailerInput'>
                        <textarea name="trailerInp" id="trailerInp" placeholder='Insert your prompt'></textarea>
                        <IoMdSend id='trailerSend'/>
                    </div>
                </div>
                <div id='trailerSuggestions'>
                    <h2>Trailer Suggestions</h2>
                    <ul id='trailerSuggestionsList'>
                        <li>You should add <NavLink to='https://www.youtube.com/watch?v=MS6dhZc6uac'>this</NavLink> background music to add suspense. </li>
                        <li>You should add more saturation in this section. 0:30 to 0:45</li>
                    </ul>
                </div>
            </div>
            <div id='trailerUploadWrapper'>
                <form id='trailerUpload'>
                    <input type="file" name="trailerUploadInp" id="trailerUploadInp" />
                </form>
                <iframe title='trailer' src="https://www.youtube.com/embed/watch?v=_GuOjXYl5ew" frameBorder="0"></iframe>
                <p>Timestamp: 1:20</p>
                <div id='frames'>
                    <button className='frame'>Add Frame</button>
                    <button className='frame'>Remove Frame</button>
                </div>
            </div>
        </div>
    )
}
